export default "__VITE_ASSET__DtmWwygP__"